import { render, staticRenderFns } from "./SiteProductsTable.vue?vue&type=template&id=c0616afc"
import script from "./SiteProductsTable.vue?vue&type=script&lang=js"
export * from "./SiteProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports